import api from './api';

class UtilService {
  getCurrentYear() {
    return api.get('secure/util/currentyear');
  }

  getLeagues() {
    return api.get('secure/util/leagues');
  }
}

export default new UtilService();